import axios from 'axios';

const langchainApi = axios.create({
    baseURL: process.env.REACT_APP_LANGCHAIN_API_URL
});

export default langchainApi;